import { SEO } from "@/components/SEO";
import { BelievingHappyHero } from "../components/site/believing-happy/BelievingHappyHero";
import { NothingWrong } from "../components/site/believing-happy/NothingWrong";
import { SomewhereAlongTheWay } from "../components/site/believing-happy/SomewhereAlongTheWay";
import { LifetimeWall } from "../components/site/believing-happy/LifetimeWall";
import { WhatBelievingHappyIs } from "../components/site/believing-happy/WhatBelievingHappyIs";
import { TheWork } from "../components/site/believing-happy/TheWork";
import { LeavingClues } from "../components/site/believing-happy/LeavingClues";
import { AllowedToWant } from "../components/site/believing-happy/AllowedToWant";
import { InsideBelievingHappy } from "../components/site/believing-happy/InsideBelievingHappy";
import { TheProgression } from "../components/site/believing-happy/TheProgression";
import { GroupVsPrivate } from "../components/site/believing-happy/GroupVsPrivate";
import { FinalInvitation } from "../components/site/believing-happy/FinalInvitation";

export default function BelievingHappy() {
  return (
    <div data-testid="believing-happy-page">
      <SEO
        title="Believing Happy"
        description="Believing Happy is a 10-week Blueprint4Joy® experience to get radically honest about where you are, get clear about what you really want and start bridging the gap between the two."
        path="/believing-happy"
      />
      <BelievingHappyHero />
      <div aria-hidden="true" className="h-[44px] bg-[#FAFAF8]" />
      <NothingWrong />
      <SomewhereAlongTheWay />
      <LifetimeWall />
      <WhatBelievingHappyIs />
      <TheWork />
      <LeavingClues />
      <AllowedToWant />
      <InsideBelievingHappy />
      <TheProgression />
      <GroupVsPrivate />
      <FinalInvitation />
    </div>
  );
}
